<template>
  <div class="Lib">
    <div class="PageZg">{{ title }}</div>

    <CardsSwitcher :show="show" @switchTo="switchTo"></CardsSwitcher>

    <CardPreviews :cards="cards(show)"></CardPreviews>

    <div class="Fraza">Вместе каждый может больше!</div>
  </div>
</template>

<script>
import CardsSwitcher from "@/components/CardsSwitcher.vue";
import CardPreviews from "@/components/CardPreviews.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CardsSwitcher, CardPreviews
  },
  props: {
    title: String,
    tagId: Number
  },
  data() {
    return {
      show: 'visible',
    }
  },
  methods: {
    switchTo(newType) {
      this.show = newType;
      this.$store.dispatch('loadCardsByTag', {tagId: this.tagId, type: this.show});
    },
    cards(show) {
      return this.$store.getters.cardsByTag(this.tagId, this.show);
    },
  },
  // created: function() {
  //   this.$store.dispatch('loadCardsByTag', {tagId: this.tagId, type: this.show});
  // }
};
</script>
